import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Types } from 'src/app/constants/gift-card-type';
import { GiftCardService } from 'src/app/services/gift-card.service';
import { LoginService } from 'src/app/services/login.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-buy-gift-cards',
  templateUrl: './buy-gift-cards.page.html',
  styleUrls: ['./buy-gift-cards.page.scss'],
})
export class BuyGiftCardsPage implements OnInit {
  public isCoupon = this._route.snapshot.queryParamMap.get('isCoupon');
  public uri = '';
  public types = Types;

  constructor(
    private _route: ActivatedRoute,
    private _giftCardSv: GiftCardService,
    private _loginSv: LoginService,
    private _navCtrl: NavController,
    private _storageSv: StorageService
  ) {}

  ngOnInit() {
    this.setTypeUri();
  }

  setTypeGiftCard(type: string) {
    this.isCoupon = type;
    this.setTypeUri();
  }

  setTypeUri() {
    this.uri =
      this.isCoupon === this.types.COUPON ? 'coupon/all' : 'giftCard/all';
  }

  async setGiftCard(event) {
    const role = await this._giftCardSv.setTransferType();
    this._storageSv.setLocalStorage('giftCard', JSON.stringify(event));
    if (role === 'cancel') {
      this._giftCardSv.client = this._loginSv.user;
    }
    await this._navCtrl.navigateForward('wallet/transactions', {
      queryParams: {
        uri: this.uri,
      },
    });
    // if (role === 'cancel') {
    //   this.setClient(this.loginSv.user);
    // } else if (this.user) {
    //   this.setClient(this.user);
    // }
  }
}
